const Header = (props) => {
    return (
        <header>
            <h1>{props.title}</h1>
            <p>{props.content}</p>
        </header>
    )
}

Header.defaultProps = {
    title: 'Benin City',
    Content: 'Abuja'
}
export default Header
